// @flow
import React from 'react';
import Box from './box';

/**
 */
export default function Text(props: {}) {
  return <Box is="p" {...props} />;
}
